import { Component } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, EffectFade } from 'swiper/modules';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/effect-fade';

interface Props {
  images: string[];
}

export class SliderComponent extends Component<Props, any> {
  render() {
    const { images } = this.props;

    return (
      <Swiper
        modules={[Autoplay, EffectFade]}
        effect="fade"
        loop={true}
        autoplay={{
          delay: 6500,
          disableOnInteraction: false,
        }}
        className="fade-zoom-swiper h-100"
      >
        {images.map((image) => (
          <SwiperSlide>
            <div className="zoom-container">
              <img src={image} alt={'Image'} className={'img-fluid w-100'} />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    );
  }
}
